module.exports = __webpack_public_path__ + "img/start.9815055c.svg";